<template>
  <v-card>
    <v-toolbar flat light color="white" v-if="$vuetify.breakpoint.smAndDown">
      <v-spacer></v-spacer>
      <v-btn light icon @click="$emit('close')">
        <v-icon>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider v-if="$vuetify.breakpoint.smAndDown"></v-divider>
    <v-container class="pb-0" v-if="$vuetify.breakpoint.mdAndUp && step==0">
      <v-row justify="end">
        <v-col class="shrink">
          <v-btn color="color-grey" depressed right text small @click="$emit('close')">
            <v-icon class="mr-3">fa-times</v-icon>
            <span>{{ $t('close') }}</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="pt-0 pb-16" fluid>
      <v-stepper v-model="step" class="elevation-0">
        <v-stepper-items class="elevation-0">
          <v-stepper-content step="0" class="elevation-0 pa-0 ">


      <v-row justify="center">
          <v-img :src="chatIcon.svg" :height="200" :width="200" contain />
      </v-row>
      <v-row justify="center">
        <v-col class="text-center">
          <h3 class="mt-4 text-h3">{{ $t('contact-header') }}</h3>
        </v-col>
      </v-row>

      <v-row no-gutters justify="center">
              <v-col cols="12" sm="10">
                <p class="text-center small-margin">{{ $t('contact-desc-1') }}</p>
                <p class="text-center">{{ $t('contact-desc-2') }}</p>
              </v-col>
              <v-col cols="12" sm="10" v-cloak @drop.prevent="addDropFile" @dragover.prevent>
                <v-row class="justify-center">
                  <v-col cols="12">
                    <p class="ok-title bold">{{ $t('contact-headertext') }} *</p>
                    <v-text-field
                                v-model="headerText"
                                @blur="$v.headerText.$touch()"
                                @change="$v.headerText.$touch()"
                                :error-messages="headerTextError"
                                outlined
                                :counter="100">
                    </v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <p class="ok-title bold">{{ $t('contact-text') }} *</p>
                    <v-textarea outlined
                                  v-model="text"
                                  @blur="$v.text.$touch()"
                                  @change="$v.text.$touch()"
                                  :error-messages="textError"
                                  auto-grow
                                  :counter="2000">
                    </v-textarea>
                  </v-col>

                  <v-col cols="12" v-if="countDebts > 1">
                    <p class="ok-title bold">{{ $t('contact-debt') }} *</p>
                    <v-select
                      color="color-new-link-blue"
                      outlined
                      @blur="$v.selectedFormattedDebt.$touch()"
                      :error-messages="debtError"
                      @change="handleDebtChange"
                      :items="formattedDebts"
                      v-model="selectedFormattedDebt"
                    ></v-select>
                  </v-col>

                  <v-col cols="12">
                    <p class="ok-title bold">{{ $t('contact-attachments') }}</p>
                    <v-file-input v-model="files"
                                  :error-messages="fileErrors"
                                  @blur="$v.files.$touch()"
                                  multiple
                                  prepend-inner-icon="fas fa-paperclip"
                                  prepend-icon=""
                                  outlined
                                  :accept="fileTypes"
                                  :show-size="1000">
                      <template v-slot:selection="{ index, text }">
                        <v-chip v-if="index < 2"
                                color="primary"
                                dark
                                label
                                small>
                          {{ text }}
                        </v-chip>
                        <span v-else-if="index === 2" class="mx-2">
                          +{{ files.length - 2 }} {{ $t('contact-attachment') }}
                        </span>
                      </template>
                    </v-file-input>
                  </v-col>

                  <v-col cols="12">
                    <p class="ok-title bold">{{ $t('contact-preferredcontact') }} *</p>
                    <v-radio-group v-model="desiredContactMethod" hide-details row style="margin-top: 0;">
                      <v-radio color="color-new-link-blue" :label="$t('contact-phone-select')" value="0"></v-radio>
                      <v-radio color="color-new-link-blue" :label="$t('contact-email-select')" value="1"></v-radio>
                    </v-radio-group>
                  </v-col>

                  <!-- Phone number input box -->
                  <v-col cols="12" v-if="desiredContactMethod === '0'">
                    <p class="ok-title bold">{{ $t('contact-phone') }} *</p>
                    <v-text-field
                      name="phone"
                      prefix="+358"
                      class="long-prefix"
                      outlined
                      id="phone"
                      @blur="$v.phone.$touch()"
                      v-model="phone"
                      :error-messages="phoneError"
                      :counter="12"
                    ></v-text-field>
                  </v-col>

                  <!-- Email input box -->
                  <v-col cols="12" v-if="desiredContactMethod === '1'">
                    <p class="ok-title bold">{{ $t('contact-email') }} *</p>
                    <v-text-field
                      outlined
                      v-model="email"
                      @blur="$v.email.$touch()"
                      @change="$v.email.$touch()"
                      :error-messages="emailError"
                      :counter="50"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                </v-row>
              </v-col>
            </v-row>

            <v-row justify="center">
              <div class="pa-5">
                <v-btn tile class="primary wide-button" @click="sendContactRequest" :loading="loading" :disabled="!isValid || loading">
                  <span>{{ $t('contact-confirm') }}</span>
                </v-btn>
              </div>
            </v-row>

          </v-stepper-content>
          <v-stepper-content step="1" class="elevation-0 pa-3 pt-16">
            <v-row>
              <v-col cols="12">
                <h2 class="text-h2 mt-0 text-center">
                  {{ $t('contact-wait') }}...
                </h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-progress-circular :size="100" color="primary" indeterminate />
              </v-col>
            </v-row>
          </v-stepper-content>
          <v-stepper-content step="2" class="elevation-0 pa-3 pt-16">
            <v-row no-gutters justify="center">
              <div class="pa-3">
                <v-icon :size="150" color="color-green">
                  fa-check-circle
                </v-icon>
              </div>
            </v-row>
            <v-row>
              <v-col cols="12">
                <h3 class="mt-4 text-h1 text-center">{{ $t('contact-done') }}</h3>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" sm="10">
                <p class="text-center">{{ $t('contact-done-desc') }}</p>
              </v-col>
            </v-row>
            <v-row justify="center">
              <div class="pa-3">
                <v-btn tile outlined dark color="color-new-link-blue" class="wide-button" @click="resetContactForm">
                  <span>{{ $t('contact-close') }}</span>
                </v-btn>
              </div>
            </v-row>
          </v-stepper-content>

          <v-stepper-content step="3" class="elevation-0 pa-3 pt-16">
            <v-row no-gutters justify="center">
              <div class="pa-3">
                <i class="far fa-frown" style="font-size: 150px;"></i>
              </div>
            </v-row>
            <v-row>
              <v-col cols="12">
                <h3 class="mt-4 text-h1 text-center">{{ $t('contact-error') }}</h3>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" sm="10">
                <p class="text-center">{{ $t('contact-error-desc') }}</p>
              </v-col>
            </v-row>
            <v-row justify="center">
              <div class="pa-3">
                <v-btn tile outlined dark color="color-new-link-blue" class="wide-button" @click="resetContactForm">
                  <span>{{ $t('contact-close') }}</span>
                </v-btn>
              </div>
            </v-row>
          </v-stepper-content>

          </v-stepper-items>
          </v-stepper>
    </v-container>
  </v-card>
</template>

<script>
  import { apiResource } from '@/util/resources'
  import { required, email, numeric, minLength, maxLength } from 'vuelidate/lib/validators'
  const allowedFiletypes = ['.pdf', '.rtf', '.doc', '.docx', '.xls', '.xlsx', '.msg', '.jpg', '.png', '.bmp', '.tiff', '.jpeg']
  const fileSize = function (value) {
    var totalSize = 0
    for (var i = 0; i < value.length; i++) {
      totalSize += value[i].size
    }
    return totalSize <= 20000000
  }

  const isNoLeadingZero = (value) => !value.startsWith('0')
  const fileTypes = function (value) {
    for (var i = 0; i < value.length; i++) {
      let fileType = value[i].name.substring(value[i].name.lastIndexOf('.'))
      if (allowedFiletypes.indexOf(fileType) < 0) {
        return false
      }
    }

    return true
  }

  export default {
    data: function () {
      return {
        headerText:'',
        text: '',
        name: '',
        email: '',
        phone: '',
        files: [],
        fileTypes: allowedFiletypes,
        chatIcon: {
          "name": "Contact",
          "svg": "static/chat.svg"
        },
        desiredContactMethod: null, // 0 = phone, 1 = email
        debts: [],
        debt:null,
        selectedFormattedDebt: null,
        step: 0, //0 = contact form, 1 = loading, 2 = confirm, 3 = error
      }
    },
    mounted() {
      this.step = 0;
      this.$matomo && this.$matomo.trackEvent("Action", "Send Message", "Send Message In Progress")
    },
    computed: {
      allDebts() {
        return this.$store.getters.allDebts
      },
      countDebts() {
        return this.allDebts.length
      },
      formattedDebts() {
        return this.allDebts.map(debt => {
          const ordernr = debt.orderNr || 'Unknown ID';
          const creditorname = debt.creditor.name || 'Unknown Name';
          const amount = debt.debtSummary.capital || 0;
          const paid = debt.debtSummary.state.ended ? this.$t('paid') : '';

          return {
            text: `${ordernr} ${creditorname} (${amount}€) ${paid}`,
            value: debt
          };
        });
      },
      loading () {
        return this.$store.getters.loading
      },
      isValid () {
        if (this.debt &&
          (!this.$v.text.$error && this.$v.text.$dirty) &&
          (!this.$v.headerText.$error && this.$v.headerText.$dirty) &&
          !this.$v.files.$error)
          {//Checks if fields are valid, and if they are, then open up the "sendContactRequest" button
            if((this.desiredContactMethod == 1 && (!this.$v.email.$error && this.$v.email.$dirty))
              || (this.desiredContactMethod == 0 && (!this.$v.phone.$error && this.$v.phone.$dirty)))
              {
                return true
              }
              else{
                return false
              }

        }
        else {
          return false
        }
      },
      textError () {
        const errors = []
        if (!this.$v.text.$dirty) return errors
        !this.$v.text.required && errors.push(this.$t('textErrors.required'))
        !this.$v.text.minLength && errors.push(this.$t('textErrors.length'))
        !this.$v.text.maxLength && errors.push(this.$t('textErrors.length'))
        return errors
      },
      headerTextError () {
        const errors = []
        if (!this.$v.headerText.$dirty) return errors
        !this.$v.headerText.required && errors.push(this.$t('headerTextErrors.required'))
        !this.$v.headerText.minLength && errors.push(this.$t('headerTextErrors.length'))
        !this.$v.headerText.maxLength && errors.push(this.$t('headerTextErrors.length'))
        return errors
      },
      debtError () {
        const errors = []
        if (!this.$v.selectedFormattedDebt.$dirty) return errors
        !this.$v.selectedFormattedDebt.required && errors.push(this.$t('debtErrors.required'))
        return errors
      },
      fileErrors () {
        const errors = []
        if (!this.$v.files.$dirty) return errors
        !this.$v.files.fileSize && errors.push(this.$t('fileSizeError'))
        !this.$v.files.fileTypes && errors.push(this.$t('fileTypesError'))
        return errors
      },
      emailError () {
        if(this.desiredContactMethod == 1){
          const errors = []
          if (!this.$v.email.$dirty) return errors
          !this.$v.email.required && errors.push(this.$t('validation.email.required'))
          !this.$v.email.email && errors.push(this.$t('validation.email.email'))
          !this.$v.email.maxLength && errors.push(this.$t('validation.email.length'))
          return errors
        }
      },
      phoneError () {
        if(this.desiredContactMethod == 0){
          const errors = []
          if (!this.$v.phone.$dirty) return errors
          !this.$v.phone.required && errors.push(this.$t('phoneNrErrors.required'))
          !this.$v.phone.numeric && errors.push(this.$t('phoneNrErrors.numeric'))
          !this.$v.phone.minLength && errors.push(this.$t('phoneNrErrors.length'))
          !this.$v.phone.maxLength && errors.push(this.$t('phoneNrErrors.length'))
          !this.$v.phone.isNoLeadingZero && errors.push(this.$t('phoneNrErrors.leadingZero'))
          return errors
        }
      },
    },
    methods: {
      setDefaultDebt() { //Is triggered when the window is opened by a reference from HeaderToolbar and HeaderDrawer
        if (this.countDebts === 1) {
          this.selectedFormattedDebt = this.formattedDebts[0];
          this.debt = this.formattedDebts[0].value;
        }
      },
      handleDebtChange(selectedDebt) {
        this.updateSelectedDebt(selectedDebt);
        this.$v.selectedFormattedDebt.$touch();
      },
      updateSelectedDebt(selectedDebt) {
        this.debt = selectedDebt;
      },
      sendContactRequest () {
        if (this.isValid) {
          this.formatPhoneNumber()
          this.$store.commit('setLoading', true)
          this.step=1

          var formData = new FormData();
          formData.append('orderNr', this.debt.nr)
          formData.append('registerDate', Date.now())
          formData.append('headerText', this.headerText)
          formData.append('text', this.text)
          formData.append('phone', this.phone)
          formData.append('email', this.email)

          this.files.forEach(file => {
            const originalName = file.name.split('.').slice(0, -1).join('.');
            const extension = file.name.split('.').pop();
            const newName = `${originalName}_${this.debt.nr}.${extension}`;
            const renamedFile = new File([file], newName, { type: file.type });
            formData.append('files', renamedFile);
          });

          const formDataEntries = {};
          formData.forEach((value, key) => {
            if (key !== 'files') {
              formDataEntries[key] = value;
            }
          });
          formData.append('language', this.$store.getters.longLocale)

          apiResource.post('api/orders/contactRequest', formData).then((response) => {
            this.$store.commit('setLoading', false)

            if (response.data.status === 0) {
              if (response.data.responseObject === true) {
                this.step=2
                this.$matomo && this.$matomo.trackEvent("Action", "Send Message", "Send Message Complete")
              } else {
                this.step=3
                this.$store.commit('setMessage', { type: 'error', text: response.data.errorCode, translate: true })
                this.$matomo && this.$matomo.trackEvent("Action", "Send Message", "Send Message Failed")
              }
            } else {
              this.step=3
              this.$store.commit('setMessage', { type: 'error', text: response.data.errorCode, translate: true })
              this.$matomo && this.$matomo.trackEvent("Action", "Send Message", "Send Message Failed")
            }
          }).catch((errorResponse) => {
            this.step=3
            this.$store.commit('setLoading', false)
            this.$store.commit('setMessage', { type: 'error', text: 'error.generic.0', translate: true })
            this.$matomo && this.$matomo.trackEvent("Action", "Send Message", "Send Message Failed")
          })
        }
      },
      resetContactForm() {
        this.$emit('close');
        setTimeout(() => {
          this.$nextTick(() => {
            this.step = 0;
          });
        }, 200); //Timeout of 200ms to make it smooth setting step = 0.
      },
      formatPhoneNumber () {
        if(this.phone.startsWith('0')) {
          this.phone = this.phone.substring(1)
        }
      },
    },
    validations:{
      text:{
        required,
        minLength:minLength(10),
        maxLength: maxLength(1000)
      },
      headerText: {
        required,
        minLength:minLength(5),
        maxLength: maxLength(100)
      },
      selectedFormattedDebt:{
        required
      },
      files: {
        fileSize,
        fileTypes
      },
      email: {
        required,
        email,
        maxLength: maxLength(50)
      },
      phone: {
        required,
        numeric,
        minLength: minLength(2),
        maxLength: maxLength(12),
        isNoLeadingZero
      },
    }

  }
</script>

<i18n>
  {
  "fi": {
  "contact-header": "Ota yhteyttä",
  "contact-desc-1": "Tähdellä (*) merkityt kentät ovat pakollisia. Vastaamme viesteihin 3-5 arkipäivän kuluessa.",
  "contact-desc-2": "Mikäli asiasi on kiireellinen, otathan yhteyttä asiakaspalveluumme puhelimitse.",
  "contact-confirm": "Lähetä viesti",
  "contact-headertext": "Viestin otsikko",
  "contact-text": "Viestin sisältö",
  "contact-debt": "Valitse velka jota asiasi koskee",
  "contact-attachments": "Liitteet",
  "contact-attachment": "tiedosto(a)",
  "contact-preferredcontact": "Haluan että B2 Impact ottaa minuun yhteyttä",
  "contact-email-select": "Sähköpostitse",
  "contact-phone-select": "Puhelimitse",
  "contact-email": "Sähköpostiosoite",
  "contact-phone": "Puhelinnumero",

  "contact-wait": "Viestiä lähetetään, odota hetki",

  "contact-done": "Kiitos Viestistäsi",
  "contact-done-desc": "Asiakaspalvelumme vastaa sinulle 3-5 arkipäivän kuluessa.",

  "contact-close": "Sulje ikkuna",

  "contact-error":"Lähetys epäonnistui",
  "contact-error-desc":"Viestin lähetys ei onnistunut teknisen virheen takia. Ole hyvä ja yritä uudelleen.",
  "paid":"MAKSETTU",


  "phoneNrErrors": {
    "required": "Syötä puhelinnumero",
    "numeric": "Puhelinnumeron tulee olla numero",
    "length": "Puhelinnumeron tulee olla 1-12 numeroa pitkä",
    "leadingZero": "Puhelinnumeron ei tule alkaa nollalla"
  },
  "textErrors": {
    "required": "Syötä saate",
    "length": "Saatteen tulee olla 10-2000 merkkiä pitkä"
  },
  "headerTextErrors": {
    "required": "Syötä otsikko",
    "length": "Otsikon tulee olla 5-100 merkkiä pitkä"
  },
  "debtErrors": {
    "required": "Velka on valittava"
  },
    "fileSizeError": "Liiteiden koko on liian iso",
    "fileTypesError": "Tiedostotyyppi ei ole sallittu"
  },



  "se": {
  "contact-header": "Kontakta oss",
  "contact-desc-1": "Fält markerade med en stjärna (*) är obligatoriska. Vi svarar på meddelanden inom 3-5 arbetsdagar.",
  "contact-desc-2": "Om ditt ärende är brådskande, vänligen kontakta vår kundservice per telefon.",
  "contact-confirm": "Skicka meddelande",
  "contact-headertext": "Meddelandets ämne",
  "contact-text": "Meddelandets innehåll",
  "contact-debt": "Välj skuld som ditt ärende gäller",
  "contact-attachments": "Bilagor",
  "contact-attachment": "fil(er)",
  "contact-preferredcontact": "Jag vill att B2 Impact kontaktar mig",
  "contact-email-select": "Via e-post",
  "contact-phone-select": "Via telefon",
  "contact-email": "E-postadress",
  "contact-phone": "Telefonnummer",

  "contact-wait": "Meddelandet skickas, vänta en stund",

  "contact-done": "Tack för ditt meddelande",
  "contact-done-desc": "Vår kundservice svarar dig inom 3-5 arbetsdagar.",
  "contact-close": "Stäng fönstret",

  "contact-error": "Sändningen misslyckades",
  "contact-error-desc": "Sändningen av meddelandet misslyckades på grund av ett tekniskt fel. Var god försök igen.",
  "paid":"BETALAD",

  "phoneNrErrors": {
    "required": "Telefonnummer är obligatoriskt",
    "numeric": "Telefonnummer bör vara numeriskt",
    "length": "Telefonnummer bör vara mellan 8-9 tecken",
    "leadingZero": "Telefonnumret får inte börja med noll"
  },
  "textErrors": {
    "required": "Fyll i meddelande",
    "length": "Meddelande bör vara mellan 10-1000 tecken"
  },
  "headerTextErrors": {
    "required": "Ange ämne",
    "length": "Ämnet måste vara 5-100 tecken långt"
  },
  "debtErrors": {
    "required": "Skulden måste väljas"
  },
    "fileSizeError": "Bilagan är för stor",
    "fileTypesError": "Denna filtyp tillåts inte"
  },

  "en": {
  "contact-header": "Contact us",
  "contact-desc-1": "Fields marked with an asterisk (*) are mandatory. We respond to messages within 3-5 business days.",
  "contact-desc-2": "If your matter is urgent, please contact our customer service by phone.",
  "contact-confirm": "Send message",
  "contact-headertext": "Message subject",
  "contact-text": "Message content",
  "contact-debt": "Select the debt your matter concerns",
  "contact-attachments": "Attachments",
  "contact-attachment": "file(s)",
  "contact-preferredcontact": "I want B2 Impact to contact me",
  "contact-email-select": "By email",
  "contact-phone-select": "By phone",
  "contact-email": "Email address",
  "contact-phone": "Phone number",

  "contact-wait": "Message is being sent, please wait a moment",

  "contact-done": "Thank you for your message",
  "contact-done-desc": "Our customer service will respond to you within 3-5 business days.",
  "contact-close": "Close window",

  "contact-error": "Sending failed",
  "contact-error-desc": "The message could not be sent due to technical error. Please try again.",
  "paid":"PAID",

  "phoneNrErrors": {
    "required": "Phone number is mandatory",
    "numeric": "Phone number must be numeric",
    "length": "Phone number must be between 8-9 numbers long",
    "leadingZero": "Phone number must not start with zero"
  },
  "textErrors": {
    "required": "Fill in description",
    "length": "Description must be between 10-1000 characters"
  },
  "headerTextErrors": {
    "required": "Enter subject",
    "length": "Subject must be 5-100 characters long"
  },
  "debtErrors": {
    "required": "Debt must be selected"
  },
  "fileSizeError": "Attachment size too big",
  "fileTypesError": "File type is not allowed"
  }
  }
</i18n>

<style>
.small-margin {
  margin-bottom: 5px !important;
}
</style>
